/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import environmentConfig from '@/config/environment';
import axios from 'axios';

/**
 * Axios client for third-party API requests (e.g., Yext, BazaarVoice, external services)
 * This client does not include AutoZone-specific headers, cookies, or interceptors
 */
export const thirdPartyClient = axios.create({
  timeout: environmentConfig.DEFAULT_TIMEOUT,
});

/**
 * Get the third-party axios client
 * Can be used on both client and server
 */
export const getThirdPartyAxios = () => {
  return thirdPartyClient;
};
